/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var roadDropDownExists = function (el) {
        var dropDownElms = el.querySelectorAll('.box_road_dropwon .dropdownChildToggler');
        if (!dropDownElms) {
            return;
        }
        MoyaLoader.js('/static/local/road/js/dropdown.min.js').then(function (res) {
            var dropDown = MoyaContainer.get('road.dropdown-toggle');
            dropDownElms.forEach(function (elm) {
                dropDown.create(elm);
            });
        });
    };
    roadDropDownExists(document);

}());
typeof tsBuild === 'function' && tsBuild();})();
